import * as ProgressPrimitive from '@radix-ui/react-progress';
import * as React from 'react';

import { cn } from '@/helpers/ui-utils';

const Progress = React.forwardRef<
  React.ElementRef<typeof ProgressPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof ProgressPrimitive.Root>
>(({ className, value, ...props }, ref) => (
  <ProgressPrimitive.Root
    ref={ref}
    className={cn(
      'relative h-4 w-full overflow-hidden rounded-full bg-card',
      className,
    )}
    {...props}
  >
    <ProgressPrimitive.Indicator
      // Named 'progress-indicator', not 'indicator': daisyUI ships its own
      // .indicator component class, and in the production build daisyUI's
      // cascade layer is registered after Tailwind's `utilities` layer (it's
      // first encountered later in the generated CSS), so it silently won
      // over our utility classes — collapsing this element's width to
      // max-content regardless of the w-full/h-full utilities below.
      className={cn([
        'progress-indicator',
        'h-full',
        'w-full',
        'flex-1',
        'rounded-full',
        'bg-primary',
        'transition-all',
        'duration-1000',
        'ease',
      ])}
      style={{ transform: `translateX(-${100 - (value || 0)}%)` }}
    />
  </ProgressPrimitive.Root>
));
Progress.displayName = ProgressPrimitive.Root.displayName;

export default Progress;
